import React from 'react';
import PostList from '../components/PostList';

const App = () => {
    return (

        <div className="ui container">
            <PostList />

        </div>

    )
}

export default App;
